import { saveBlobAsFile } from 'shared/file/saveBlobAsFile'
import { getErrorMessage } from '../../../../helpers/errors.helper'
import { extractFileNameFromContentPositionHeader } from '../../../../helpers/axios-header.helper'
import { fetchGuaranteeCalculationFile } from '../api/http'

function useDownloadTaxesCalculation() {
  const downloadTaxesCalculation = async (transitOperationId: number, xlsx: boolean): Promise<void> => {
    try {
      const result = await fetchGuaranteeCalculationFile({
        id: transitOperationId,
        xlsx,
      })

      const { data } = result
      const filename = extractFileNameFromContentPositionHeader(result)

      saveBlobAsFile(data, filename)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
      throw new Error(getErrorMessage(e) ?? 'Error occurred when fetching taxes calculation')
    }
  }

  return {
    downloadTaxesCalculation,
  }
}

export default useDownloadTaxesCalculation
